module.exports = __webpack_public_path__ + "img/63.49233d65.webp";